import React, { useContext } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";

import { LayoutContext } from "App/common/hoc/Layout";
import { SPopupContext } from "App/common/hoc/SlidingPopup";
import Loader from "App/common/ui/Loader";
import { decodeHandler, sortArray } from "utils";
import Volumes from "../../DetailedProgress/volumes";

import { ReactComponent as VolDisk } from "assets/images/app_svg/volumeDisk.svg";

import { initiateStopBackup } from "store/actions";

function BackupProgress(props) {
  const { lState, lMethods } = useContext(LayoutContext);
  const { sPopupMethods } = useContext(SPopupContext);
  const progress =
    props.clients[lState.slidingPopup.params.clientUUID].status.progress;
  const detailedProgress = progress.diskInfo;
  const machineStatus =
    props.clients[lState.slidingPopup.params.clientUUID].machineStatus;
  const status =
    props.enums.BackupScheduleStatus.props[
      props.clients[lState.slidingPopup.params.clientUUID].status.value
    ].key;

  if (
    progress.completed ||
    progress.failed ||
    status === "CANCELLED" ||
    status === "PAUSED" ||
    machineStatus === "offline"
  ) {
    const timer = setTimeout(() => {
      lMethods.closeSlidingPopup();
      clearTimeout(timer);
    }, 1000);
  }

  return (
    <React.Fragment>
      {detailedProgress ? (
        <div className="slider_content_backup">
          <div className="slider_summary">
            <div className="slider_content_body">
              <div className="view_list_logs_wrap__body">
                <div className="vll_item_heading">
                  <h3>View progress of the backup</h3>
                </div>

                {Object.keys(detailedProgress).map((disk, i) => (
                  <div className="vll_item vll_progress" key={i}>
                    <div className="vll_item__head flex_align">
                      <div className="vll_item__head__icon vm_icn">
                        <VolDisk />
                      </div>
                      <div
                        className="vll_item__head__name"
                        title="Automation-Test"
                      >
                        {disk}
                      </div>
                    </div>
                    <div className="vll_item__content">
                      <div className="vll_item_backup_progress">
                        {sortArray(detailedProgress[disk], "drive").map(
                          (vol, k) => {
                            const volStatusKey =
                              props.enums.BackupScheduleStatus.props[vol.status]
                                .key;

                            return (
                              <Volumes
                                volume={vol}
                                key={k}
                                k={k}
                                volStatusKey={volStatusKey}
                                type={"backup"}
                              />
                            );
                          }
                        )}
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
            <div className="slider_content_footer">
              <div className="slider_summary_btns">
                <div className="slider_summary_btns__inner">
                  <div className="backup_image_btns just_flex">
                    <div
                      className="slider_btn slider_btn_delete"
                      onClick={() => {
                        sPopupMethods.openPopup("cancelBackup", {
                          body: {
                            CLIENT_NAME: decodeHandler(
                              props.clients[
                                lState.slidingPopup.params.clientUUID
                              ].name
                            )
                          },
                          execute: () => {
                            props.initiateStopBackup(
                              lState.slidingPopup.params.clientUUID
                            );
                            sPopupMethods.closePopup();
                            lMethods.closeSlidingPopup();
                          }
                        });
                      }}
                    >
                      Stop Backup
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      ) : (
        <Loader />
      )}
    </React.Fragment>
  );
}

function mapStateToProps(state) {
  return {
    clients: state.dashboard.clients.list,
    enums: state.common.enums
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      initiateStopBackup
    },
    dispatch
  );
}

export default connect(mapStateToProps, mapDispatchToProps)(BackupProgress);
